import { partLabel, isNewCond } from "@/lib/store";

export const AppleMark = ({ className = "" }) => (
  <svg viewBox="0 0 384 512" aria-hidden="true" className={className} fill="currentColor">
    <path d="M318.7 268.7c-.2-36.7 16.4-64.4 50-84.8-18.8-26.9-47.2-41.7-84.7-44.6-35.5-2.8-74.3 20.7-88.5 20.7-15 0-49.4-19.7-76.4-19.7C63.3 141.2 4 184.8 4 273.5q0 39.3 14.4 81.2c12.8 36.7 59 126.7 107.2 125.2 25.2-.6 43-17.9 75.8-17.9 31.8 0 48.3 17.9 76.4 17.9 48.6-.7 90.4-82.5 102.6-119.3-65.2-30.7-61.7-90-61.7-91.9zm-56.6-164.2c27.3-32.4 24.8-61.9 24-72.5-24.1 1.4-52 16.4-67.9 34.9-17.5 19.8-27.8 44.3-25.6 71.9 26.1 2 49.9-11.4 69.5-34.3z" />
  </svg>
);

export const OriginalSeal = ({ testid, label = "Original Apple" }) => (
  <span data-testid={testid} className="inline-flex items-center gap-1.5 rounded-full border border-white/20 bg-white/[0.06] px-2.5 py-1 text-xs font-medium text-white">
    <AppleMark className="h-3 w-3" /> {label}
  </span>
);

export const isAllOriginal = (p) => p?.category !== "acessorios" && (isNewCond(p?.condition) || (p?.condition === "seminovo" && p?.parts_status === "original"));

export const PartsInfo = ({ p }) => {
  if (isAllOriginal(p)) {
    return (
      <div data-testid="product-parts-info" className="mt-5 flex flex-wrap items-center gap-3">
        <OriginalSeal testid="product-parts-original-seal" />
        <span className="text-sm text-zinc-400">{isNewCond(p.condition) ? "Lacrado de fábrica, 100% original" : "Todas as peças originais de fábrica"}</span>
      </div>
    );
  }
  const parts = Array.isArray(p?.parts) ? p.parts : [];
  if (p?.parts_status !== "trocadas" || !parts.length) return null;
  return (
    <div data-testid="product-parts-info" className="mt-5">
      <p className="mono text-[11px] uppercase tracking-[0.22em] text-zinc-400">Peças trocadas</p>
      <ul className="mt-2 flex flex-wrap gap-2">
        {parts.map((x) => (
          <li key={x.part} data-testid={`product-part-${x.part}`} className="inline-flex items-center gap-2 rounded-full border border-white/10 py-1 pl-3 pr-1 text-sm text-zinc-200">
            {partLabel(x.part)}
            {x.original ? <OriginalSeal testid={`product-part-original-${x.part}`} />
              : x.genuine ? <OriginalSeal testid={`product-part-genuine-${x.part}`} label="Genuína Apple" />
              : <span className="pr-2" />}
          </li>
        ))}
      </ul>
    </div>
  );
};
